import { render, staticRenderFns } from "./AssestmentReview.vue?vue&type=template&id=4e6fbebc&scoped=true"
import script from "./AssestmentReview.vue?vue&type=script&lang=js"
export * from "./AssestmentReview.vue?vue&type=script&lang=js"
import style0 from "./AssestmentReview.vue?vue&type=style&index=0&id=4e6fbebc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6fbebc",
  null
  
)

export default component.exports